import { Stack, TextField, Typography } from "@mui/material";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

const CustomTextArea = ({
  control,
  name,
  label,
  rules = {},
  stackProps = {},
  labelPosition = "",
  paramsFunc = () => ({}),
  slotProps: callerSlotProps = {},
  ...others
}) => {
  const mergedSlotProps = {
    ...callerSlotProps,
    htmlInput: {
      style: { fontSize: "12px" },
      ...callerSlotProps.htmlInput,
    },
    input: {
      ...callerSlotProps.input,
    },
  };

  return (
    <Stack
      {...stackProps}
      flexDirection={labelPosition === "left" ? "row" : "column"}
      spacing={1}
      className="custom-input-container field-container"
    >
      {(labelPosition === "top" || labelPosition === "left") && (
        <Typography className="label" variant="subtitle2">
          {label || ""}
        </Typography>
      )}

      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            {...field}
            inputRef={ref}
            size="small"
            value={field?.value || ""}
            label={labelPosition ? "" : label || ""}
            margin="dense"
            fullWidth
            variant="outlined"
            error={Boolean(error)}
            helperText={error?.message || ""}
            multiline
            rows={4}
            {...others}
            slotProps={mergedSlotProps}
            {...paramsFunc({ field })}
          />
        )}
      />
    </Stack>
  );
};

export default memo(CustomTextArea);
